import script from "./ourBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./ourBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./ourBusiness.vue?vue&type=style&index=0&id=0efdbf12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efdbf12"]])

export default __exports__